<template>
    <div v-if="deliveryfound" class="alert alert-danger">
        {{ $translate("Klettershop5::Template.deliverySubText") }}
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {
                deliveryfound: false
            };
        },
        created:function()
        {
            vueEventHub.$on("nodelivery", bool =>
            {
                if(bool === true)
                {
                    this.deliveryfound = true;
                }
            });
        }
    }
</script>
